import Vue from 'vue'
import Vuex from 'vuex'
import modelvVideo from './modelvVideo'
import modelAnswer from './modelAnswer'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        currentExam: {
            type: '',
            title: ''
        },
        HomeInfo: {},


    },
    mutations: {
        SET_CURRENT_EXAM(state, payload) {
            state.currentExam = payload;
        }
    },
    // 模块
    modules: {
        modelvVideo,
        modelAnswer
    },

});